import styled from "styled-components";

export type TitleConfig = React.HTMLAttributes<HTMLSpanElement>;

export const Title = styled.span<TitleConfig>`
  font-family: var(--typography-title-font-family);
  font-weight: var(--typography-title-font-weight);
  font-size: var(--typography-title-font-size-desktop);
  line-height: var(--typography-title-line-height);
  letter-spacing: var(--typography-title-letter-spacing);

  @media (max-width: 768px) {
    font-size: var(--typography-title-font-size-mobile);
  }

  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;
